// extracted by mini-css-extract-plugin
export default {"tableRecommended":"interested_tableRecommended__AZhBa","panelSelect":"interested_panelSelect__lKxjE"};